import clsx from 'clsx';
import React, {Suspense, useState} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import SafeDrivingMainTripItemLoadingKr from '@di-shared/features/safe-driving/kr/SafeDrivingMainTripItemLoading.kr';
import SafeDrivingMainTripListKr from '@di-shared/features/safe-driving/kr/SafeDrivingMainTripList.kr';

export enum TripTab {
  SAFE_DRIVING,
  RECKLESS_DRIVING,
}
export const MAIN_TRIP_DEFAULT_PAGE = 1;
export const MAIN_TRIP_SIZE = 3;

export interface SafeDrivingMainTripKrProps {
  vin: string;
}

function SafeDrivingMainTripKr({vin}: SafeDrivingMainTripKrProps) {
  const {t} = useInferableTranslation();
  const [selectedTripTab, setSelectedTripTab] = useState<TripTab>(TripTab.RECKLESS_DRIVING);
  const [isSafeDrivingFetchMore, setIsSafeDrivingFetchMore] = useState(false);
  const [isRecklessDrivingFetchMore, setIsRecklessDrivingFetchMore] = useState(false);
  const [isTripAvailable, setIsTripAvailable] = useState(true);

  function changeTab(tabName: TripTab) {
    setSelectedTripTab(tabName);
  }

  if (!isTripAvailable) {
    return null;
  }

  return (
    <div className="section_container safe_driving_major">
      <div className="section_container_header">
        <h3 className="title_xxsmall">{t('T20013')}</h3>
      </div>
      <p className="section_container_desc">{t('T20014')}</p>

      <div
        className="tabbar type_brick"
        role="tablist"
      >
        <button
          type="button"
          className={clsx('tabbar_item body_small_b', {'is-selected': selectedTripTab === TripTab.RECKLESS_DRIVING})}
          onClick={() => changeTab(TripTab.RECKLESS_DRIVING)}
          id={`${TripTab.RECKLESS_DRIVING}_tab`}
          role="tab"
          aria-selected={selectedTripTab === TripTab.RECKLESS_DRIVING}
          aria-controls={`${TripTab.RECKLESS_DRIVING}_tabpanel`}
          tabIndex={selectedTripTab === TripTab.RECKLESS_DRIVING ? 0 : -1}
        >
          {t('T20015')}
        </button>
        <button
          type="button"
          className={clsx('tabbar_item body_small_b', {'is-selected': selectedTripTab === TripTab.SAFE_DRIVING})}
          onClick={() => changeTab(TripTab.SAFE_DRIVING)}
          id={`${TripTab.SAFE_DRIVING}_tab`}
          role="tab"
          aria-selected={selectedTripTab === TripTab.SAFE_DRIVING}
          aria-controls={`${TripTab.SAFE_DRIVING}_tabpanel`}
          tabIndex={selectedTripTab === TripTab.SAFE_DRIVING ? 0 : -1}
        >
          {t('T20016')}
        </button>
      </div>
      {selectedTripTab === TripTab.RECKLESS_DRIVING && (
        <Suspense fallback={<SafeDrivingMainTripItemLoadingKr />}>
          <SafeDrivingMainTripListKr
            vin={vin}
            selectedTripTab={selectedTripTab}
            isFetchMore={isRecklessDrivingFetchMore}
            onUpdateFetchMore={() => setIsRecklessDrivingFetchMore((prev) => !prev)}
            onUpdateIsTripAvailable={setIsTripAvailable}
          />
        </Suspense>
      )}
      {selectedTripTab === TripTab.SAFE_DRIVING && (
        <Suspense fallback={<SafeDrivingMainTripItemLoadingKr />}>
          <SafeDrivingMainTripListKr
            vin={vin}
            selectedTripTab={selectedTripTab}
            isFetchMore={isSafeDrivingFetchMore}
            onUpdateFetchMore={() => setIsSafeDrivingFetchMore((prev) => !prev)}
            onUpdateIsTripAvailable={setIsTripAvailable}
          />
        </Suspense>
      )}
    </div>
  );
}

export default SafeDrivingMainTripKr;
